/*
* ***********************************Example of Usage***********************************
*
* 1 - Simple usage
*    <ButtonClickWrapper onClick={myClick}>
*      <button/>
*    </ButtonClickWrapper>
*
* 2 - Enabling Dynamic behaviour (Decides if it will either execute or not the function defined)
*    <ButtonClickWrapper onClick={myClick} disabled={canIClick()}>
*      <button/>
*    </ButtonClickWrapper>
*
* 3 - Enabling redirection
*    <ButtonClickWrapper href={{url: "https://www.google.com", name: "_top"}}>
*      <button/>
*    </ButtonClickWrapper>
*/

"use strict";

var ButtonClickWrapper = React.createClass({
  propTypes: {
    children: React.PropTypes.node.isRequired,
    disabled: React.PropTypes.bool,
    href: React.PropTypes.shape({
      url: React.PropTypes.string,
      name: React.PropTypes.string
    }),
    onClick: React.PropTypes.func
  },
  getDefaultProps: function() {
    return {
      disabled: false,
      href: null,
      onClick: null
    };
  },
  handleClick: function() {
    var handleOnClick;

    if(this.props.disabled){
      handleOnClick = function() { return null; };
    } else if(this.props.href) {
      handleOnClick = function() {
        return window.open(this.props.href.url, this.props.href.name);
      }.bind(this);
    } else {
      handleOnClick = this.props.onClick;
    }

    return handleOnClick;
  },
  applyOnClick: function() {
    var childNode = this.props.children;
    var extraProps = {
      onClick: this.handleClick()
    };
    return React.cloneElement(childNode, extraProps);
  },
  render: function() {
    return (this.applyOnClick());
  }
});


module.exports = ButtonClickWrapper;



// WEBPACK FOOTER //
// ./app/shared/components/Button/button-click-wrapper.jsx